import siteInfo from "@/constants/siteInfo";
import Head from "next/head";

const OrganisationSchema = () => {
  return (
    <Head>
      <script
        id="NewsMediaOrganizationSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsMediaOrganization",
            "@id": `${process.env.NEXT_PUBLIC_WEBSITE_URL}/#newsmediaorganization`,
            name: "NewsTak",
            url: `${process.env.NEXT_PUBLIC_WEBSITE_URL}/`,
            description:
              "NewsTak is a Hindi news platform covering politics, education, crime, entertainment, regional and national news.",
            logo: {
              "@type": "ImageObject",
              url: siteInfo?.newSiteLogo,
              width: 600,
              height: 60,
            },
            address: {
              "@type": "PostalAddress",
              streetAddress: "FC-8, Ecity Bioscope Rd, Film City, Sector 16A",
              addressLocality: "Noida",
              addressRegion: "Uttar Pradesh",
              postalCode: "201301",
              addressCountry: "IN",
            },
            sameAs: [
              siteInfo.socialLinks.facebook,
              siteInfo.socialLinks.twitter,
              siteInfo.socialLinks.instagram,
              siteInfo.socialLinks.youtube,
            ],
          }),
        }}
      />
    </Head>
  );
};

export default OrganisationSchema;
